// extracted by mini-css-extract-plugin
export var header = "_v7-1";
export var maskBottom = "_v7-6";
export var maskMiddle = "_v7-7";
export var maskTop = "_v7-5";
export var root = "_v7-0";
export var scrollDownButton = "_v7-3";
export var scrollDownButtonHidden = "_v7-4";
export var viewport = "_v7-2";